module.exports = __webpack_public_path__ + "static/media/transilluminator-closed-with-gel-illunminated.c99782d5.svg";